import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import Button from "../ui-components/Button";
import Select from "@ui-components/Select";

const ConfiguratorSurveyBoolQuestion = ({ value, onClick, disabled=false, canonicalRender=false }) => {

  const intl = useIntl();

  if (canonicalRender)
    return (
      <Select
        value={value}
        onChange={(e) => {
          let v;
          switch (e.target.value) {
            case "true": v = true; break;
            case "false": v = false; break;
            default: v = undefined;
          }
          onClick(v);
        }}
        disabled={disabled}
        options={[
          {name: "", value: ""},
          {name: _.capitalize(intl.formatMessage({id: "yes"})), value: "true"},
          {name: _.capitalize(intl.formatMessage({id: "no"})), value: "false"},
        ]}
      />
    );

  return (
    <div className="flex items-left py-2">
      <Button
        styleType={value ? "default" : "empty"}
        className="w-20 mr-4"
        onClick={() => onClick(true)}
        disabled={disabled}
      >
        <FormattedMessage id="yes" />
      </Button>
      <Button
        styleType={value === false ? "default" : "empty"}
        className="w-20"
        onClick={() => onClick(false)}
        disabled={disabled}
      >
        <FormattedMessage id="no" />
      </Button>
    </div>
  );
};

export default ConfiguratorSurveyBoolQuestion;
